<template>
  <div class="d-flex flex-column flex-md-row align-center justify-center">
    <template v-for="({ text, to, dropdown }, i) in menu">
      <v-btn
        v-if="!dropdown"
        v-bind="getLinkAttrs(to, server)"
        :class="buttonClass"
        :color="color"
        :height="buttonHeight"
        :block="xsOnly"
        :key="i"
        active-class="nav-link-active"
        depressed
        tile
        text
      >
        {{ text }}
      </v-btn>

      <v-menu v-else offset-y tile :key="i + '_menu'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :class="buttonClass"
            :color="color"
            :height="buttonHeight"
            active-class="nav-link-active"
            :block="xsOnly"
            depressed
            tile
            text
          >
            {{ text }}
            <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
          </v-btn>
        </template>
        <v-list tile>
          <v-list-item
            v-for="(item, keyDropdown) in dropdown"
            :key="keyDropdown"
            v-bind="getLinkAttrs(item.to, server)"
          >
            <v-list-item-title class="text-body-2 text-body-md-1">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>

<script>
import { menu } from "../../config";
import { getLinkAttrs } from "../../utils/getLinkAttrs";

export default {
  props: {
    color: {
      type: String,
      default: "white",
    },
  },
  data: () => ({
    menu,
  }),
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    buttonHeight() {
      return this.xsOnly ? 36 : 54;
    },
    buttonClass() {
      return [
        "text-body-2 text-body-md-1 font-weight-light text-none px-1 px-md-3 px-lg-5 py-5 nav-link",
      ];
    },
  },
  methods: {
    getLinkAttrs,
  },
  beforeCreate() {
    menu.forEach((item) => {
      if (item.callback && !item._called) {
        item.callback(this);
        item._called = true;
      }

      return item;
    });
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  &:before {
    opacity: 0 !important;
  }

  &:after {
    background-color: transparent;
    bottom: 10px;
    content: "";
    height: 2px;
    left: 50%;
    margin-left: 0;
    position: absolute;
    transition: all 0.1s linear;
    width: 0;
  }

  &:hover {
    &:after {
      background-color: var(--v-grey-base);
      margin-left: -23px;
      width: 46px;
    }
  }
}
</style>
